export const GET_POLICY_VALIDATE_REQUEST = 'GET_POLICY_VALIDATE_REQUEST';
export const GET_POLICY_VALIDATE_SUCCESS = 'GET_POLICY_VALIDATE_SUCCESS';
export const GET_POLICY_VALIDATE_ERROR = 'GET_POLICY_VALIDATE_ERROR';
